// utils/dashboardConstants.js
// Shared constants and configurations for dashboards

/**
 * Time-off categories that should be excluded from available hours
 */
export const TIME_OFF_CATEGORIES = ['Vacation', 'Sick', 'Holiday', 'PTO'];

/**
 * Default section collapse states
 */
export const DEFAULT_SECTION_STATE = {
  // Client Servicing
  overServicingCollapsed: false,
  customerCollapsed: false,
  
  // Team Servicing
  productivityCollapsed: false,
  metricsCollapsed: false,
  employeeCollapsed: false,
  productivityTrendsCollapsed: false,
};

/**
 * Cache refresh endpoints
 */
export const CACHE_ENDPOINTS = {
  CLIENT_SERVICING: '/time-activity/cache/refresh',
  TEAM_SERVICING: '/time-activity/cache/refresh',
};

/**
 * Document metadata
 */
export const DOCUMENT_TITLES = {
  FINANCE: 'Pulse: Finance',
  PLAYGROUND: 'Pulse: Playground',
  CLIENT: 'Pulse: Client Servicing',
  TEAM: 'Pulse: Team Servicing',
  MARKETING: 'Pulse: Marketing',
  SALES: 'Pulse: Sales',
  CONFIGURATION:'Pulse: Configuration',
  DATA_SYNC: 'Pulse: Data Sync',
};

/**
 * Profitability thresholds
 */
export const PROFITABILITY_THRESHOLDS = {
  HIGH: 30,
  MEDIUM: 15,
};

/**
 * Productivity thresholds
 */
export const PRODUCTIVITY_THRESHOLDS = {
  HIGH: 0.75,
  MEDIUM: 0.5,
};

/**
 * KPI Definitions for tooltips
 */
export const KPI_DEFINITIONS = {
  // Client Servicing
  profitability: "Profit margin calculated as (Invoiced Fees - Billable Incurred) / Invoiced Fees × 100. Shows the percentage of revenue retained as profit after covering billable costs. Higher percentages indicate better profitability.",
  totalHours: "Sum of all billable hours worked across all clients during the period. Includes both project and retainer work.",
  totalClients: "Number of unique clients with billable activity during the period. Includes both project-based and retainer clients.",
  quarterlyData: "Hours worked and profitability percentage for this specific quarter.",
  
  // Team Servicing
  productivity: "Percentage of available hours spent on client work. Calculated as Client Hours ÷ Available Hours × 100. Higher percentages indicate better productivity.",
  utilization: "Percentage of total hours spent on client work. Calculated as Client Hours ÷ Total Hours × 100.",
  clientHours: "Total hours worked on client projects and retainer work.",
  availableHours: "Total hours minus time off (vacation, sick, holiday, PTO).",
  
  // Sales
  totalLeads: "Total number of leads generated during the selected period. Tracks overall lead generation effectiveness.",
  qualificationRate: "Percentage of leads that meet qualification criteria. Higher rates indicate better lead quality and targeting.",
  proposalRate: "Percentage of leads that receive formal proposals. Measures sales team engagement and opportunity development.",
  winRate: "Percentage of proposals that convert to closed deals. Key indicator of sales effectiveness and proposal quality.",
};